module.exports = __webpack_public_path__ + "img/chevron-down.7738783a.svg";